import CustomGenericTittleIconDataChip from "../../../../components/CustomGenericTittleIconDataChip";
import {
    IconAnchor
} from "../../../../components/buttons/IconButtons";
import React from "react";
import {REQUEST_DOCUMENTATION_FONT_COLOR_MODEL} from "../Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 05/12/2025
 */

const RequestTrailList = ({
                              item,
                              getStatusIcon,
                              elementRef,
                              levelRefsRef,
                              onSelectLevel
                          }) => {

    const handleScrollToLevel = (index) => {
        const target = levelRefsRef.current[index]?.current;
        if (target) {
            target.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }

        onSelectLevel?.(index);
    };

    return (
        <div  ref={elementRef} className="border-radius-8px border-full-shades-100 position-sticky t-10px h-100">
            <div className={"col-12 d-flex justify-content-between align-items-center p-3"}>
                <CustomGenericTittleIconDataChip
                    className="m-0"
                    Icon={IconAnchor}
                    title="trail"
                    border={false}
                />
            </div>
            <div className="border-bottom-shades-300 pt-1" />
            <div className={"p-3 overflow-y-auto request-tab-column"}>
                {
                    item?.levels?.map((level, index) =>  {
                        return (
                            <div className={"row cursor-pointer"} key={index} onClick={() => handleScrollToLevel(index)}>
                                <div className={"col-2 d-flex flex-column justify-content-space-evenly align-items-center"} >
                                    {getStatusIcon(level?.userLevel?.statusId, index, item?.levels)}
                                </div>
                                <div className={"col-10"}>
                                    <p className={`fs-16px ibl-font-w-600 ${REQUEST_DOCUMENTATION_FONT_COLOR_MODEL[level?.userLevel?.statusId]}`}>{level?.name}</p>
                                    <span className={"fs-14px ibl-font-w-400 font-color-shades-700"}>{level?.department?.name}</span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    )

}

export default RequestTrailList
